import { NavLink, useLocation } from "react-router-dom";
import { Home, Store, Users, User } from "lucide-react";
import { useAuth } from "@/App";

/**
 * Mobile-only sticky bottom navigation.
 * Five tabs (Home / Businesses / Blinterest (gold B) / Community / Profile).
 * Uses safe-area-inset-bottom for notched devices.
 */
export default function MobileBottomNav() {
  const location = useLocation();
  const { user } = useAuth();

  // Hide on admin + auth flows where the nav clutters the workflow.
  if (
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/join") ||
    location.pathname.startsWith("/register") ||
    location.pathname.startsWith("/reset-password") ||
    location.pathname.startsWith("/checkout") ||
    location.pathname.startsWith("/subscription/success")
  ) {
    return null;
  }

  const items = [
    { to: "/", label: "Home", icon: Home, testid: "bottom-nav-home", exact: true },
    { to: "/directory", label: "Businesses", icon: Store, testid: "bottom-nav-directory" },
    { to: "/blinterest", label: "Blinterest", icon: null, testid: "bottom-nav-blinterest", brand: true },
    { to: "/events", label: "Community", icon: Users, testid: "bottom-nav-community" },
    {
      to: user ? "/dashboard" : "/join",
      label: "Profile",
      icon: User,
      testid: "bottom-nav-profile",
    },
  ];

  const isActive = (to, exact) => {
    if (exact) return location.pathname === to;
    return location.pathname === to || location.pathname.startsWith(to + "/");
  };

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-tbc-navy border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-bottom-nav"
    >
      <ul className="flex items-stretch justify-around h-16">
        {items.map((it) => {
          const active = isActive(it.to, it.exact);
          const Icon = it.icon;
          return (
            <li key={it.to} className="flex-1">
              <NavLink
                to={it.to}
                className="flex flex-col items-center justify-center h-full text-[10px] tracking-wide"
                data-testid={it.testid}
              >
                {it.brand ? (
                  <span
                    className={`w-10 h-10 rounded-full flex items-center justify-center font-heading text-lg -mt-4 mb-0.5 border-4 border-tbc-navy ${
                      active
                        ? "bg-tbc-gold text-tbc-navy shadow-lg shadow-tbc-gold/30"
                        : "bg-white/10 text-white"
                    }`}
                  >
                    B
                  </span>
                ) : (
                  <Icon
                    className={`w-5 h-5 mb-0.5 ${
                      active ? "text-tbc-gold" : "text-white/70"
                    }`}
                  />
                )}
                <span className={active ? "text-tbc-gold font-semibold" : "text-white/70"}>
                  {it.label}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
